import { set } from 'lodash';
import { sessionRemotes } from '../../components/form/session-remote';

export function updateToken(token: unknown) {
    if (!token || typeof token !== 'string') {
        throw new Error(
            `invalid input provided to updateToken, got '${token}', expected non-empty string`
        );
    }

    const authorization = token.startsWith('Bearer ')
        ? token
        : `Bearer ${token}`;

    for (const remote of sessionRemotes.values()) {
        remote.set(
            set(
                structuredClone(remote.state),
                'request.headers.authorization',
                authorization
            )
        );
    }
}
